import LeaveTicketDetail from './LeaveTicketDetail';

export default LeaveTicketDetail;
